export default __webpack_public_path__ + "static/media/sparkles.c4f20e6c.svg";